import { MapProvider } from 'react-map-gl';
import React, { FC, PropsWithChildren } from 'react';
import { IExploreFacade } from './explore-facade';
import { ILayerFactory } from './map/layers/deck-gl-layer-factory';
import { IPOIFactory } from './poi-model';
import { IPoiReportableFactory } from './poi-reportable-factory';
import { IPoiPresenterFactory } from './poi-presenters/presenter-factory';

export interface IExploreContext {
    exploreFacade?: IExploreFacade;
    plMapboxLayersFactory?: ILayerFactory;
    poiFactory?: IPOIFactory;
    poiReportableFactory?: IPoiReportableFactory;
    poiPresenterFactory?: IPoiPresenterFactory;
}

export const ExploreContext = React.createContext<IExploreContext>({});

export const ExploreContextProvider: FC<PropsWithChildren<Required<IExploreContext>>> = (props) => {
    const { children, ...rest } = props;

    return (
        <MapProvider>
            <ExploreContext.Provider value={rest}>
                {children}
            </ExploreContext.Provider>
        </MapProvider>
    );
};
